import React, { useState, useEffect } from 'react';
import { useCart } from '../CartContext';
import './FloatingCartButton.css';

export default function FloatingCartButton({ navigate }) {
  const { total, itemCount } = useCart();
  const [visible, setVisible] = useState(false);
  const [popped, setPopped] = useState(false);
  const prevCount = React.useRef(itemCount);

  useEffect(() => {
    setVisible(itemCount > 0);
    if (itemCount > prevCount.current) {
      setPopped(true);
      setTimeout(() => setPopped(false), 500);
    }
    prevCount.current = itemCount;
  }, [itemCount]);

  if (!visible) return null;

  return (
    <div className={`floating-cart ${popped ? 'pop' : ''}`} onClick={() => navigate('cart')}>
      <div className="fc-left">
        <span className="fc-icon">🛒</span>
        <span className="fc-count">{itemCount} item{itemCount > 1 ? 's' : ''}</span>
      </div>
      <div className="fc-center">View Cart</div>
      <div className="fc-total">₹{total.toLocaleString()}</div>
    </div>
  );
}
